import { FC } from "react";
import { Field as ChakraField, RadioGroup, Stack } from "@chakra-ui/react";
import { useField } from "formik";

interface RadioProps {
  options: { title: string; value: string }[];
  name: string;
  label: string;
}

// v3's `RadioGroup.Item` is only a wrapper: the visible circle is `ItemIndicator` and the real
// input is `ItemHiddenInput`, so the group is driven through Formik's helpers instead of `<Field>`.
const Radio: FC<RadioProps> = ({ options, name, label }) => {
  const [field, , helpers] = useField(name);

  return (
    <ChakraField.Root mt={4} className="input" width="100%">
      {label && <ChakraField.Label>{label}</ChakraField.Label>}
      <RadioGroup.Root
        name={name}
        width="100%"
        size="sm"
        colorPalette="blue"
        value={field.value ?? null}
        onValueChange={({ value }) => helpers.setValue(value)}
      >
        <Stack direction="row" w="100%">
          {options.map((option) => (
            <RadioGroup.Item key={option.value} value={option.value} gap={2} fontWeight="normal">
              <RadioGroup.ItemHiddenInput onBlur={field.onBlur} />
              <RadioGroup.ItemIndicator borderWidth="2px" />
              <RadioGroup.ItemText fontSize="xs">{option.title}</RadioGroup.ItemText>
            </RadioGroup.Item>
          ))}
        </Stack>
      </RadioGroup.Root>
    </ChakraField.Root>
  );
};

export default Radio;
